import { Alert, Card, Text } from '@nimbus-ds/components';
import { NotificationDetailsDto } from '@tiendanube/common';
import { PHISHING_SUSPECT_TAG } from 'App/featuresFlags';
import { useHasTags, useNavegate } from 'App/hooks';
import {
  CancelAndSaveButtons,
  Layout,
  Stack,
  TabsMultiLanguage,
  useResponsive,
} from 'commons/components';
import { SetFieldValue } from 'commons/hooks/useForm/types';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import { EmailValues } from './EmailValues';
import { PhishingSuspectAlert } from './PhishingSuspectAlert';
import { VariablesInfoCard } from './VariablesInfoCard';
import { PickupEmailItemCardAlert } from '../../NotificationsListPage/components/PickupEmailItemCardAlert';

interface EmailNotificationTabProps {
  email: NotificationDetailsDto;
  values: NotificationDetailsDto;
  setFieldValue: SetFieldValue;
  handleOnSubmit: () => void;
  updateStatus: 'idle' | 'loading' | 'success' | 'error';
  hasError: boolean;
  isDirty: boolean;
  isOrderPickupEmail: boolean;
}

export function EmailNotificationTab({
  email,
  values,
  setFieldValue,
  handleOnSubmit,
  updateStatus,
  hasError,
  isDirty,
  isOrderPickupEmail,
}: Readonly<EmailNotificationTabProps>) {
  const t = useTranslationConfigurations('notifications.editNotificationPage');
  const { isMobile } = useResponsive();
  const { goBack } = useNavegate();
  const [isPhishingSuspect] = useHasTags([PHISHING_SUSPECT_TAG]);

  return (
    <>
      <Alert show={hasError} appearance="danger">
        <Text>{t('formCard.templateHtml.errorValidation')}</Text>
      </Alert>
      <PhishingSuspectAlert
        isPhishingSuspect={isPhishingSuspect}
        isError={updateStatus === 'error'}
      />
      {isOrderPickupEmail && <PickupEmailItemCardAlert />}
      <Layout
        mainContent
        left={
          <Stack column align="flex-end">
            <Card>
              <Card.Header>
                <Text fontSize="highlight" fontWeight="bold">
                  {t('formCard.title')}
                </Text>
              </Card.Header>
              <Card.Body>
                <TabsMultiLanguage>
                  <EmailValues
                    values={values}
                    initialValues={email}
                    isPhishingSuspect={isPhishingSuspect}
                    setFieldValue={setFieldValue}
                  />
                </TabsMultiLanguage>
              </Card.Body>
            </Card>
            {!isMobile && (
              <CancelAndSaveButtons
                onCancel={goBack}
                onSave={handleOnSubmit}
                isDisabled={!isDirty || isPhishingSuspect}
                isLoading={updateStatus === 'loading'}
              />
            )}
          </Stack>
        }
        right={<VariablesInfoCard emailVariables={email.variables} />}
      />
      {isMobile && (
        <CancelAndSaveButtons
          onCancel={goBack}
          onSave={handleOnSubmit}
          isDisabled={!isDirty || isPhishingSuspect}
          isLoading={updateStatus === 'loading'}
        />
      )}
    </>
  );
}
